module.exports = __webpack_public_path__ + "img/1.5ed63d7b.webp";